import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.ClickableText
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.LastBaseline
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ui.login.LoginViewModel
import ui.login.loginViewModel

@Composable
fun SubmittedScreen(
    loginViewModel: LoginViewModel = loginViewModel(),
) {
    Column(
        modifier = Modifier.padding(top = 16.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        var color = remember { mutableStateOf(Color.Blue) }
        Text("Thank you, we will send a verification link to your phone number", modifier = Modifier.padding(horizontal = 32.dp))
        Row(modifier = Modifier.padding(horizontal = 32.dp, vertical = 16.dp).fillMaxWidth())
        {
            Text("Did not receive the text?", fontSize = 12.sp, modifier = Modifier.padding(end = 8.dp).alignBy(LastBaseline))
            ClickableText(
                text = buildAnnotatedString {
                    withStyle(
                        style = SpanStyle(
                            color = color.value,
                            fontSize = 12.sp,
                            fontWeight = FontWeight.Normal,
                            textDecoration = TextDecoration.Underline
                        )
                    ) { append("Resend") }
                }, modifier = Modifier.alignBy(LastBaseline),
                onClick = {
                    loginViewModel.submitPhoneNumber {
                        color.value = Color.Gray
                    }
                }
            )
        }
    }
}